module.exports = __webpack_public_path__ + "static/media/haul-track.77db7868.jpeg";